import Module from './input'
export default Module
